/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RelationCompetencesEvaluationScopeFilter } from './relationCompetencesEvaluationScopeFilter';
import { RelationCompetencesEvaluationIncludeFilterItems } from './relationCompetencesEvaluationIncludeFilterItems';


export interface RelationCompetencesEvaluationIncludeFilterInner { 
    relation?: RelationCompetencesEvaluationIncludeFilterInner.RelationEnum;
    scope?: RelationCompetencesEvaluationScopeFilter;
}
export namespace RelationCompetencesEvaluationIncludeFilterInner {
    export type RelationEnum = 'jobCategory' | 'competence';
    export const RelationEnum = {
        JobCategory: 'jobCategory' as RelationEnum,
        Competence: 'competence' as RelationEnum
    };
}


